import React from 'react'

import IncidentsRequestsListTable from '../../components/itsm-list-table/itsm-list-table-incidents-requests/itsm-list-table-incidents-requests'

import {useGetIncidentRequestAssetQuickFilters} from '@/modules/ITSM/hooks/use-get-incident-request-asset-quick-filters'

import {TIncident} from '../../components/incident-k-request/typedf'
import {ItsmAssets} from '../../typedef'

const Requests = () => {
  const {
    assetQuickFilters,
    isLoading,
  } = useGetIncidentRequestAssetQuickFilters()

  return (
    <IncidentsRequestsListTable<TIncident>
      asset={ItsmAssets.Requests}
      assetQuickFilters={assetQuickFilters}
      isAssetQuickFiltersLoading={isLoading}
    />
  )
}

export default Requests
